import React from 'react'
import { Viewport } from '@chilecompra/react-kit'

import DesktopFiltersView from './QuoteSearchFilters.desktop'
import MobileFiltersView from './QuoteSearchFilters.mobile'

import { SecondaryFiltersWrapper } from './QuoteSearchFilters.styles'

/*
 * The QuoteSearchFilters' container.
 */
const QuoteSearchFilters = () => (
  <SecondaryFiltersWrapper>
    <Viewport rule={size => size.isDownToSmall || size.isDownToLarge}>
      <MobileFiltersView />
    </Viewport>
    <Viewport rule={size => size.isUpToMedium || size.isUpToLarge}>
      <DesktopFiltersView />
    </Viewport>
  </SecondaryFiltersWrapper>
)

export default QuoteSearchFilters
